exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--19RROqOtVO84jM-KBoyZbW {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  white-space: pre;\n  font-size: .875rem;\n  line-height: 1.25rem;\n  letter-spacing: .2px;\n  color: #252733;\n}\n", ""]);

// exports
exports.locals = {
	"assigneesContainer": "care-team-tasks--19RROqOtVO84jM-KBoyZbW",
	"assigneesContainer": "care-team-tasks--19RROqOtVO84jM-KBoyZbW"
};